import gql from 'graphql-tag'

export const groupsQuery = gql`
  query groupsQuery($userId: ID!) {
    allGroups(filter: { AND: [{ type: "recur" }, { user: { id: $userId } }] }) {
      id
      name
      color
    }
  }
`
export const groupQuery = gql`
  query groupQuery($id: ID!) {
    Group(id: $id) {
      id
      name
      color
      type
      isStared
      isDuration
      isPublic
      startedAt
      completedAt
      minutesTotal
      trackers {
        id
        name
        color
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/group.js